import { SystemSettingsEntity } from 'api/types/entity';
import { TFunc } from 'libs/i18n';

import { AccountingSystemFormType } from '../forms/accountingSystemForm';

export const getInitialValue = (
  t: TFunc,
  settings: SystemSettingsEntity
): AccountingSystemFormType => ({
  sessionLengthInDays: settings.sessionLengthInDays,

  passwordExpiresInDays: settings.passwordExpiresInDays || undefined,

  isPasswordLimited: !!settings.passwordExpiresInDays,
});
